import { FormControl, FormGroup, Validators } from '@angular/forms';

export class InformacionPacienteModel {
	tipoDocumentoIdentidad?: 1;
	documentoIdentidad: string;
	nombre: string;
	apellido: string;
	correoElectronico: string;
	telefono: string;

	sexo?: string;  // Optional
	fechaNacimiento?: string; // Optional

	constructor(initData: {
		tipoDocumentoIdentidad?: 1,
		documentoIdentidad?: string,
		nombre?: string,
		apellido?: string,
		correoElectronico?: string,
		telefono?: string,

		sexo?: '0' | '1',
		fechaNacimiento?: string
	} = {}) {

		this.tipoDocumentoIdentidad = initData.tipoDocumentoIdentidad || 1;
		this.documentoIdentidad = initData.documentoIdentidad || '';
		this.nombre = initData.nombre || '';
		this.apellido = initData.apellido || '';
		this.correoElectronico = initData.correoElectronico || '';
		this.telefono = initData.telefono || '';

		this.sexo = initData.sexo || '';
		this.fechaNacimiento = initData.fechaNacimiento || '';

	}

	getFormGroup() {
		const group: any = {};

		group['tipoDocumentoIdentidad'] = new FormControl(this.tipoDocumentoIdentidad || '', Validators.required);
		group['documentoIdentidad'] = new FormControl(this.documentoIdentidad || '', Validators.required);
		group['nombre'] = new FormControl(this.nombre || '', Validators.required);
		group['apellido'] = new FormControl(this.apellido || '', Validators.required);
		group['correoElectronico'] = new FormControl(this.correoElectronico || '', Validators.required);
		group['telefono'] = new FormControl(this.telefono || '', Validators.required);

		group['sexo'] = new FormControl(this.sexo || '', Validators.required);
		group['fechaNacimiento'] = new FormControl(this.fechaNacimiento || '', Validators.required);

		return new FormGroup(group);
	}
}

